import { render, staticRenderFns } from "./CommpanyBrandDetail.vue?vue&type=template&id=d8bfb868&"
import script from "./CommpanyBrandDetail.vue?vue&type=script&lang=js&"
export * from "./CommpanyBrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports